import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import "./styles/ReportPage.css";
import search from "/assets/icon/Search.svg";
import DownloadReportWindow from "../../components/DownloadReportWindow";

const formatDate = (date) => {
 const options = { day: "2-digit", month: "2-digit", year: "numeric" };
 return new Date(date).toLocaleDateString("en-GB", options);
};

function ShowWaterLevelStatus24HoursReport() {
 const [startDate, setStartDate] = useState('');
 const [endDate, setEndDate] = useState('');
 const [searchQuery, setSearchQuery] = useState("");
 const [showDownloadReport, setShowDownloadReport] = useState(false);
 const [weatherData, setWeatherData] = useState([]);
 const [selectedItem, setSelectedItem] = useState(null);
 const [averageData, setAverageData] = useState(null);

 const handleDateChange = () => {
   if (startDate && endDate) {
     const start = new Date(startDate);
     const end = new Date(endDate);
     
     if (start > end) {
       alert('วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด');
       return;
     }
   }
 };

 const handleSearchChange = (event) => {
   setSearchQuery(event.target.value);
 };

 const handleClearSelection = () => {
   setSearchQuery("");
   setWeatherData([]);
   setSelectedItem(null);
   setAverageData(null);
   setStartDate('');
   setEndDate('');
 };

 const handleDownloadReportClick = () => {
   setShowDownloadReport(true);
 };

 const handleDownloadReportClose = () => {
   setShowDownloadReport(false);
 };

 const fetchWeatherData = useCallback(async () => {
   if (!searchQuery) {
     setWeatherData([]);
     return;
   }
   try {
     const response = await axios.get(
       `${import.meta.env.VITE_API_URL}/api/polesSearch?searchQuery=${searchQuery}`
     );
     setWeatherData(response.data);
   } catch (error) {
     console.error("Error fetching data:", error);
   }
 }, [searchQuery]);

 useEffect(() => {
   fetchWeatherData();
 }, [fetchWeatherData]);

 const fetchAverageData = useCallback(async () => {
   if (selectedItem && startDate && endDate) {
     try {
       const response = await axios.get(
         `${import.meta.env.VITE_API_URL}/api/poles/${selectedItem.id}/water-level-status-24hours?startDate=${startDate}&endDate=${endDate}`
       );
       setAverageData(response.data);
     } catch (error) {
       console.error("Error fetching average data:", error);
     }
   } else {
     setAverageData(null);
   }
 }, [selectedItem, startDate, endDate]);

 useEffect(() => {
   fetchAverageData();
 }, [fetchAverageData]);

 const handleItemClick = (item) => {
   if (selectedItem && selectedItem.id === item.id) {
     setSelectedItem(null);
     setSearchQuery("");
     setAverageData(null);
   } else {
     setSelectedItem(item);
     setSearchQuery(item.name);
   }
 };

 const createFileName = () => {
   if (!selectedItem || !startDate || !endDate) return "report";
   return `${selectedItem.name}_${startDate}_to_${endDate}`;
 };

 return (
   <div className="containerPage">
     <div className="showWeatherReport">
       <h1>รายงานสถานะระดับน้ำ 24 ชั่วโมง</h1>
       <h4 className="downloadReport" onClick={handleDownloadReportClick}>
         ดาวน์โหลดรายงาน
       </h4>
       <p>ดูรายงานระหว่างวันที่</p>
       <div className="sectiondatereport">
         <div className="date-inputs">
           <div className="date-input-group">
             <label>วันที่เริ่มต้น:</label>
             <input
               type="date"
               value={startDate}
               onChange={(e) => {
                 setStartDate(e.target.value);
                 handleDateChange();
               }}
               className="date-input"
             />
           </div>
           
           <div className="date-input-group">
             <label>วันที่สิ้นสุด:</label>
             <input
               type="date"
               value={endDate}
               onChange={(e) => {
                 setEndDate(e.target.value);
                 handleDateChange();
               }}
               className="date-input"
               min={startDate}
             />
           </div>
         </div>
       </div>
       <p>ค้นหารหัสเสา</p>
       <div className="searchbarreport">
         <div className="search-bar">
           <img src={search} alt="search" className="search-user" />
           <input
             type="text"
             placeholder="ค้นหาชื่อ, หมายเลขโทรศัพท์, หรืออีเมล"
             value={searchQuery}
             onChange={handleSearchChange}
           />
           {selectedItem && (
             <button className="clear-button" onClick={handleClearSelection}>
               &times;
             </button>
           )}
         </div>
       </div>

       <div className="searchResults">
         {searchQuery && (
           <>
             {selectedItem ? (
               <div
                 key={selectedItem.id}
                 className="resultItem"
                 onClick={() => handleItemClick(selectedItem)}
                 style={{ cursor: "pointer", border: "2px solid #2762F8" }}
               >
                 <p><strong>ชื่อเสา</strong> {selectedItem.name}</p>
                 <p><strong>Location</strong> {selectedItem.location}</p>
                 <p><strong>ประเภทเสา</strong> {selectedItem.pole_type}</p>
                 <p><strong>Latitude</strong> {selectedItem.lat} , {selectedItem.lng}</p>
                 <p><strong>id</strong> {selectedItem.id}</p>
               </div>
             ) : (
               weatherData.map((data) => (
                 <div
                   key={data.id}
                   className="resultItem"
                   onClick={() => handleItemClick(data)}
                   style={{ cursor: "pointer" }}
                 >
                   <p><strong>ชื่อเสา</strong> {data.name}</p>
                   <p><strong>Location</strong> {data.location}</p>
                   <p><strong>ประเภทเสา</strong> {data.pole_type}</p>
                   <p><strong>Latitude</strong> {data.lat} , {data.lng}</p>
                 </div>
               ))
             )}
           </>
         )}
       </div>
       <hr />

       {selectedItem && (
         <div className="selectedItemDetails">
           <h2>รายละเอียดเสาที่เลือก</h2>
           <p><strong>ชื่อเสา:</strong> {selectedItem.name}</p>
           <p><strong>เวลาเริ่มต้น:</strong> {startDate || "ไม่ได้เลือก"}</p>
           <p><strong>เวลาสิ้นสุด:</strong> {endDate || "ไม่ได้เลือก"}</p>
         </div>
       )}

       {selectedItem && startDate && endDate && averageData && (
         <div className="showReportSection">
           <table className="sensorDataTable">
             <thead>
               <tr>
                 <th>ปริมาณน้ำฝนเฉลี่ย (นิ้ว)</th>
                 <th>ปริมาณน้ำฝนรายวันเฉลี่ย (นิ้ว)</th>
                 <th>สถานะน้ำที่โคนเสา</th>
               </tr>
             </thead>
             <tbody>
               <tr>
                 <td>{parseFloat(averageData.avg_rainin).toFixed(2)}</td>
                 <td>{parseFloat(averageData.avg_dailyrainin).toFixed(2)}</td>
                 <td>{averageData.flood_status > 0 ? "มีน้ำ" : "แห้ง"}</td>
               </tr>
             </tbody>
           </table>
         </div>
       )}

       {showDownloadReport && (
         <DownloadReportWindow
           onClose={handleDownloadReportClose}
           jsonData={{
             poleInfo: {
               name: selectedItem?.name,
               location: selectedItem?.location,
               poleType: selectedItem?.pole_type,
               latitude: selectedItem?.lat,
               longitude: selectedItem?.lng,
               id: selectedItem?.id
             },
             reportInfo: {
               startDate: startDate,
               endDate: endDate,
             },
             averageData: {
               avgRainin: parseFloat(averageData?.avg_rainin).toFixed(2),
               avgDailyrainin: parseFloat(averageData?.avg_dailyrainin).toFixed(2),
               floodStatus: averageData?.flood_status > 0 ? "มีน้ำ" : "แห้ง"
             }
           }}
           fileName={createFileName()}
           routeName="showwaterlevel"
         />
       )}
     </div>
   </div>
 );
}

export default ShowWaterLevelStatus24HoursReport;